module.exports = __webpack_public_path__ + "img/avatar_placeholder.6fcf5eee.png";